<div class="stats-page">
  <div class="stats-head">
    <h1 class="page-title">{{ "stats.title" | translate }}</h1>
    <div class="year-switch" *ngIf="years.length > 1; else singleYear">
      <button
        type="button"
        *ngFor="let y of years"
        class="year-chip"
        [class.active]="y === selectedYear"
        (click)="selectYear(y)"
      >
        {{ y }}
      </button>
    </div>
    <ng-template #singleYear><span class="stats-year">{{ selectedYear }}</span></ng-template>
  </div>

  <div *ngIf="loading" class="stats-loading">{{ "common.loading" | translate }}</div>

  <ng-container *ngIf="!loading">

    <!-- Assaggio base (sempre visibile) -->
    <div class="mini-row">
      <div class="mini-card">
        <span class="mini-value">{{ totalEvents }}</span>
        <span class="mini-label">{{ "stats.total_events" | translate }}</span>
      </div>
      <div class="mini-card">
        <span class="mini-value">{{ eventsThisYear }}</span>
        <span class="mini-label">{{ "stats.events_in_year" | translate: { year: selectedYear } }}</span>
      </div>
    </div>

    <div class="stats-empty" *ngIf="totalEvents === 0">
      <p>{{ "stats.empty" | translate }}</p>
      <a class="btn-gold" routerLink="/eventi/nuovo">{{ "stats.empty_cta" | translate }}</a>
    </div>

    <!-- ════════ VISTA BASE: teaser Pro ════════ -->
    <section *ngIf="!canPro" class="pro-gate">
      <div class="pro-gate-inner">
        <span class="pro-gate-icon"><app-icon name="sparkle" [size]="32"></app-icon></span>
        <h2 class="pro-gate-title">{{ "stats.pro.title" | translate }}</h2>
        <p class="pro-gate-sub">{{ "stats.pro.text" | translate }}</p>
        <div class="pro-gate-preview">
          <div class="ghost-card" *ngFor="let g of [1,2,3,4]">
            <div class="ghost-line lg"></div>
            <div class="ghost-bars">
              <span *ngFor="let b of [1,2,3,4,5,6]" [style.height.%]="20 + (b * 12)"></span>
            </div>
          </div>
        </div>
        <button class="pro-gate-btn" (click)="goToPlans()">{{ "stats.pro.cta" | translate }}</button>
      </div>
    </section>

    <!-- ════════ VISTA PRO ════════ -->
    <ng-container *ngIf="canPro">

      <!-- KPI -->
      <div class="kpi-row">
        <div class="kpi-card">
          <span class="kpi-label">{{ "stats.kpi.avg_value" | translate }}</span>
          <span class="kpi-value gold">{{ avgEventValue | number:'1.0-0' }} €</span>
          <span class="kpi-sub">{{ "stats.in_year" | translate: { year: selectedYear } }}</span>
        </div>
        <div class="kpi-card">
          <span class="kpi-label">{{ "stats.kpi.revenue" | translate }}</span>
          <span class="kpi-value">{{ revenueYear | number:'1.0-0' }} €</span>
          <span class="kpi-sub">{{ "stats.estimate_year" | translate: { year: selectedYear } }}</span>
        </div>
        <div class="kpi-card">
          <span class="kpi-label">{{ "stats.kpi.collected" | translate }}</span>
          <span class="kpi-value">{{ collectedYear | number:'1.0-0' }} €</span>
          <span class="kpi-sub">{{ "stats.in_year" | translate: { year: selectedYear } }}</span>
        </div>
        <div class="kpi-card">
          <span class="kpi-label">{{ "stats.kpi.signed" | translate }}</span>
          <span class="kpi-value">{{ signedYear }}</span>
          <div class="kpi-rate">
            <div class="rate-bar"><div class="rate-fill" [style.width.%]="signRate"></div></div>
            <span class="rate-label">{{ "stats.kpi.sign_rate" | translate: { rate: signRate } }}</span>
          </div>
        </div>
        <div class="kpi-card">
          <span class="kpi-label">{{ "stats.kpi.busiest" | translate }}</span>
          <span class="kpi-value">{{ busiestMonth?.count ? busiestMonth?.label : '—' }}</span>
          <span class="kpi-sub" *ngIf="busiestMonth?.count">{{ "stats.n_events" | translate: { n: busiestMonth?.count } }}</span>
        </div>
      </div>

      <!-- Eventi per mese -->
      <section class="chart-card">
        <h3 class="section-title">{{ "stats.charts.events" | translate }}</h3>
        <div class="chart-scroll">
          <div class="chart">
            <div *ngFor="let m of months" class="bar-wrap" [class.peak]="m === busiestMonth && m.count > 0">
              <span class="bar-value" *ngIf="m.count">{{ m.count }}</span>
              <div class="bar" [style.height.%]="barHeight(m.count)"></div>
              <span class="bar-label">{{ m.label }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Fatturato per mese (stima) -->
      <section class="chart-card">
        <h3 class="section-title">{{ "stats.charts.revenue" | translate }} <span class="est-tag">{{ "stats.estimate" | translate }}</span></h3>
        <div class="chart-scroll">
          <div class="chart">
            <div *ngFor="let m of months" class="bar-wrap">
              <span class="bar-value sm" *ngIf="m.amount">{{ m.amount | number:'1.0-0' }}</span>
              <div class="bar bar-gold" [style.height.%]="revenueBarHeight(m.amount)"></div>
              <span class="bar-label">{{ m.label }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Incassato reale per mese -->
      <section class="chart-card">
        <h3 class="section-title">{{ "stats.charts.collected" | translate }}</h3>
        <div class="chart-scroll">
          <div class="chart">
            <div *ngFor="let m of months" class="bar-wrap">
              <span class="bar-value sm" *ngIf="m.collected">{{ m.collected | number:'1.0-0' }}</span>
              <div class="bar bar-collected" [style.height.%]="collectedBarHeight(m.collected)"></div>
              <span class="bar-label">{{ m.label }}</span>
            </div>
          </div>
        </div>
        <p class="chart-note" *ngIf="paidWithoutDate > 0">
          {{ "stats.collected_no_date" | translate: { amount: (paidWithoutDate | number:'1.0-0') } }}
        </p>
      </section>

      <div class="two-col">
        <!-- Trasferte -->
        <section class="chart-card">
          <h3 class="section-title"><app-icon name="car" [size]="18"></app-icon> {{ "stats.travel.title" | translate }}</h3>
          <div class="travel-grid">
            <div><span class="tg-value">{{ kmYear | number:'1.0-0' }}</span><span class="tg-label">{{ "stats.travel.km_year" | translate: { year: selectedYear } }}</span></div>
            <div><span class="tg-value">{{ kmUpcoming | number:'1.0-0' }}</span><span class="tg-label">{{ "stats.travel.km_upcoming" | translate }}</span></div>
            <div><span class="tg-value">{{ travelCostYear | number:'1.0-0' }} €</span><span class="tg-label">{{ "stats.travel.cost" | translate }}</span></div>
          </div>
        </section>

        <!-- Città -->
        <section class="chart-card">
          <h3 class="section-title"><app-icon name="pin" [size]="18"></app-icon> {{ "stats.cities.title" | translate }}</h3>
          <div *ngIf="cities.length" class="city-chips">
            <span class="city-chip" *ngFor="let c of cities">{{ c.city }} <b>{{ c.count }}</b></span>
            <span class="city-chip more" *ngIf="otherCitiesCount">{{ "stats.cities.others" | translate: { n: otherCitiesCount } }}</span>
          </div>
          <p *ngIf="!cities.length" class="empty-note">{{ "stats.cities.empty" | translate }}</p>
        </section>
      </div>

      <!-- Mappa -->
      <section class="chart-card" *ngIf="yearEventsList.length">
        <h3 class="section-title"><app-icon name="navigate" [size]="18"></app-icon> {{ "stats.map_title" | translate: { year: selectedYear } }}</h3>
        <app-events-map [events]="yearEventsList"></app-events-map>
      </section>

    </ng-container>
  </ng-container>
</div>
